import { useRef, useEffect, useState, FC } from "react";
import { StyledPath } from "./Keyframes";
import { STROKE_WIDTH, BASE_DURATION } from "./constants";

interface LetterProps {
  path: string;
  index: number;
}

const Letter: FC<LetterProps> = ({ path, index }) => {
  const pathRef = useRef<SVGPathElement>(null);
  const [pathLength, setPathLength] = useState(0);

  useEffect(() => {
    if (pathRef.current) {
      console.log(pathRef.current.getTotalLength());
      setPathLength(pathRef.current.getTotalLength());
    }
  }, []);

  const pathProps = {
    pathLength,
    strokeDasharray: pathLength,
    strokeDashoffset: pathLength,
    strokeLinejoin: "round" as "round",
    strokeWidth: 2,
    strokeLinecap: "round" as "round",
    stroke: "url(#gradient)",
    d: path,
    fill: "none",
    duration: BASE_DURATION * 24,
    delay: index * (BASE_DURATION * 0.6),
  };

  return <StyledPath ref={pathRef} {...pathProps} />;
};

export default Letter;
